import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2 rounded-2xl bg-gray-50 p-2 dark:bg-gray-800/80" }
const _hoisted_2 = ["onClick", "aria-pressed"]
const _hoisted_3 = { "aria-hidden": "true" }

import type { DeviceWallpaperTab, DeviceTabOption } from '../../composables/useDeviceWallpaperTabs'

interface Props {
  modelValue: DeviceWallpaperTab
  tabs: DeviceTabOption[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceGalleryTabs',
  props: {
    modelValue: {},
    tabs: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tab.device,
        type: "button",
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', tab.device)),
        "aria-pressed": _ctx.modelValue === tab.device,
        class: _normalizeClass([
        'inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition-all duration-200',
        _ctx.modelValue === tab.device
          ? 'bg-white text-purple-700 shadow-md ring-1 ring-purple-200 dark:bg-gray-700 dark:text-purple-200 dark:ring-purple-500/40'
          : 'text-gray-600 hover:bg-white hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white'
      ])
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(tab.emoji), 1),
        _createElementVNode("span", null, _toDisplayString(tab.shortLabel), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})